/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_DescriptionInputs */

const en_about_description = /** @type {(inputs: About_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn about PureJSON: free, secure, 100% client-side JSON tools for developers.`)
};

const ko_about_description = /** @type {(inputs: About_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON에 대해 알아보세요: 개발자를 위한 무료, 안전한 100% 클라이언트 사이드 JSON 도구.`)
};

const ja_about_description = /** @type {(inputs: About_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONについて: 開発者のための無料で安全な100%クライアントサイドJSONツール。`)
};

/**
* | output |
* | --- |
* | "Learn about PureJSON: free, secure, 100% client-side JSON tools for developers." |
*
* @param {About_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_description = /** @type {((inputs?: About_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_description(inputs)
	if (locale === "ko") return ko_about_description(inputs)
	return ja_about_description(inputs)
});